import Vue from 'vue'
import {
  ERROR_NAME_NETWORK,
  ERROR_NAME_SERVER,
  MYME_TYPES
} from '@/constants/settings.js'
import { GENERAL_FILES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const actions = {
  async [GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS] ({ dispatch }, url) {
    const model = {
      url,
      settings: {
        responseType: MYME_TYPES.ARRAYBUFFER,
        headers: { Accept: '*' }
      }
    }
    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE, { model })
  },
  async [GENERAL_FILES.ACTIONS.DOWNLOAD_FILE] ({ dispatch }, model) {
    let resp
    try {
      resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model.model, { root: true })
      dispatch(ERRORS.ACTIONS.HIDE_ERROR, null, { root: true })
    } catch (error) {
      if (error.name !== ERROR_NAME_SERVER &&
        error.name !== ERROR_NAME_NETWORK) {
        throw error
      }
      // если файл не скачивается, просто отображаем ошибку с сервера
      return
    }
    try {
      const contentType = resp.headers['content-type']
      const filename = Vue.helpers.getFileName(resp) || model.fileName
      Vue.helpers.downloadFile(resp.data, filename, contentType)
    } catch (error) {
      // если произошла ошибка при обработке пришедших данных
      await dispatch(ERRORS.ACTIONS.SHOW_AND_THROW_ERROR, error, { root: true })
    }
  }
}

export default {
  actions
}
